import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { ButtonToolbar, Col, Dropdown, MenuItem } from 'react-bootstrap';
import { push } from 'react-router-redux';
import mergeAll from 'lodash/fp/mergeAll';
import isNumber from 'lodash/fp/isNumber';

import ProgressBar from './ProgressBar';
import EditProgressModal from './modal/EditProgressModal';

import { dbUserGoals } from '../../utils/firebase';

import './GoalCard.css';

class ContextMenuToggle extends PureComponent {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        e.preventDefault();
        this.props.onClick(e);
    }

    render() {
        return (
            <i className="fa fa-ellipsis-v cursor-pointer" onClick={this.onClick} />
        );
    }
}

class GoalContextMenu extends PureComponent {
    constructor(props) {
        super(props);

        this.onSelect = this.onSelect.bind(this);
    }

    onSelect(key) {
        const { id, dispatch } = this.props;

        switch (key) {
            case "details":
                dispatch(push(`/goals/${id}`));
                break;
            case "edit":
                break;
            case "editProgress":
                break;
            case "delete":
                break;

            default:
                console.error('Unknown menu option', key);
                break;
        }
    }

    render() {
        return (
            <Dropdown id="context-menu" pullRight onSelect={this.onSelect}>
                <ContextMenuToggle bsRole="toggle" />
                <Dropdown.Menu className="goal-context-menu">
                    <MenuItem eventKey="details">
                        <i className="fa fa-list-alt" /> View Details
                    </MenuItem>
                    <MenuItem eventKey="edit">
                        <i className="fa fa-edit" /> Edit Goal
                    </MenuItem>
                    <MenuItem eventKey="editProgress">
                        <i className="fa fa-file-plus" /> Edit Progress
                    </MenuItem>
                    <MenuItem eventKey="delete">
                        <i className="fa fa-trash" /> Delete Goal
                    </MenuItem>
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

GoalContextMenu.propTypes = {
    id: PropTypes.string.isRequired,
    dispatch: PropTypes.func,
};

class GoalCard extends PureComponent {
    constructor(props) {
        super(props);

        this.onProgressClick = this.onProgressClick.bind(this);
        this.onProgressModalHide = this.onProgressModalHide.bind(this);
        this.onProgressModalSave = this.onProgressModalSave.bind(this);

        this.state = {
            showProgressModal: false,
        };
    }

    _calcStats() {
        const { goal } = this.props;

        const today = moment().startOf('day');
        const startDate = moment.utc(goal.get('start'));
        const endDate = moment.utc(goal.get('end'));

        const remainingDuration = moment.duration(endDate - startDate);
        const totalDays = Math.ceil(remainingDuration.asDays());

        const elapsedDuration = moment.duration(today - startDate);
        const elapsedDays = Math.max(0, Math.ceil(elapsedDuration.asDays()));

        const daysRemaining = totalDays - elapsedDays;

        let pastProgress = 0; // Progress before today
        let todayProgress = 0; // Progress today
        if (goal.has('progress')) {
            const todayStr = today.format('YYYY-MM-DD');
            goal.get('progress').forEach((progress, dtStr) => {
                if (dtStr === todayStr) {
                    todayProgress += progress;
                } else {
                    pastProgress += progress;
                }
            });
        }

        const finished = daysRemaining < 0;
        const totalProgress = pastProgress + todayProgress;
        const remainingWords = Math.max(0, goal.get('target', 0) - pastProgress);
        const requiredWordsPerDay = finished ? remainingWords : Math.ceil(remainingWords / daysRemaining);

        return {
            finished,
            wordsPerDay: Math.max(0, requiredWordsPerDay),
            totalWordCount: Math.max(0, totalProgress),
            todayWordCount: Math.max(0, todayProgress),
        };
    }

    onProgressClick() {
        this.setState({ showProgressModal: true });
    }

    onProgressModalHide() {
        this.setState({ showProgressModal: false });
    }

    onProgressModalSave({ date, wordCount }) {
        const { id, goal, user } = this.props;
        if (date && isNumber(wordCount)) {
            const dtStr = date.format('YYYY-MM-DD');
            const payload = mergeAll([goal.toJS(), { progress: { [dtStr]: wordCount } }]);

            dbUserGoals(user.uid).child(id).set(payload);
        }
        this.onProgressModalHide();
    }

    render() {
        const { id, goal, dispatch } = this.props;
        const { showProgressModal } = this.state;
        const { wordsPerDay, totalWordCount, todayWordCount } = this._calcStats();

        const target = Math.max(0, goal.get('target'));
        const endDate = moment.utc(goal.get('end'));

        return (
            <Col sm={6} md={4}>
                <EditProgressModal goal={goal} show={showProgressModal} onHide={this.onProgressModalHide} onSave={this.onProgressModalSave} />
                <div className="goal-card">
                    <div className="goal-card-header">
                        <div className="goal-card-header__details">
                            <div className="goal-card-header__name">{goal.get('name')}</div>
                            <div className="goal-card-header__tally">{wordsPerDay} words / day</div>
                            <div className="goal-card-header__due">Due {endDate.format('LL')}</div>
                        </div>
                        <ButtonToolbar className="goal-card-header__actions">
                            <GoalContextMenu id={id} dispatch={dispatch} />
                        </ButtonToolbar>
                    </div>
                    <div className="goal-card-body">
                        <label className="goal-card-body__label">Words Today</label>
                        <ProgressBar current={todayWordCount} total={wordsPerDay} onClick={this.onProgressClick} />
                        <label className="goal-card-body__label">Overall Progress</label>
                        <ProgressBar current={totalWordCount} total={target} onClick={this.onProgressClick} />
                    </div>
                </div>
            </Col>
        );
    }
}

GoalCard.propTypes = {
    id: PropTypes.string.isRequired,
    goal: PropTypes.object.isRequired, // ImmutableMap
    user: PropTypes.object.isRequired,
    active: PropTypes.bool,

    dispatch: PropTypes.func,
};

export default GoalCard;



// WEBPACK FOOTER //
// ./src/components/widgets/GoalCard.js